import React, { useState } from "react";

import './News.scss'





const News = () => {

  const [email, setEmail] = useState("")

  const enteringData = (event) => {
    let { name, value } = event.target;

    setEmail(value)
  }
  return (
    <div className="main_news">
      <div class="title">Stay up to speed on the latest at Flux.</div>
      <div className="form">
        <div className="line">
          <span> Email </span>
          <input
            id="newsletterEmail"
            name="email"
            type="text"
            label="Email"
            placeholder="jsmith@example.com"
            autocomplete="off"
            onChange={enteringData}
          />
        </div>
        <div className="hiden_box" style={{ height: email && email.length >= 1 ? "100%" : "0px" }}>
          <div className="line">
            <span> First Name </span>
            <input
              id="newsletterEmail"
              name="email"
              type="text"
              label="Email"
              placeholder="John"
              autocomplete="off"
            />
          </div>
          <div className="line">
            <span> Last Name </span>
            <input
              id="newsletterEmail"
              name="email"
              type="text"
              label="Email"
              placeholder="Smith"
              autocomplete="off"
            />
          </div>
          <div className="line">
            <span> Postal Code </span>
            <input
              id="newsletterEmail"
              name="email"
              type="text"
              label="Email"
              placeholder="12345-1234"
              autocomplete="off"
            />
          </div>
          <div className="btn">
            <button>
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>

  );
};

export default News;
